import { Directive, Input, ViewChild } from '@angular/core';

import { StaticInfoMenuType } from 'Angular/services/static-menus/types/static-menu-type.type';
import { StaticInfoFieldMenuItem } from 'Angular/services/static-menus/interfaces/static-info-field-menu.interface';

import { FeatureService } from 'EntitlementsApp/ts/features/feature-needed/feature.service';

import { FeatureNeededComponent } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.component';

@Directive()
export abstract class InfoFieldSelectorModalDirective {
    @ViewChild(FeatureNeededComponent) featureNeededModal!: FeatureNeededComponent;

    @Input() infoType!: StaticInfoMenuType;

    selectedInfoFields: StaticInfoFieldMenuItem[] = [];

    modalOpen: boolean = false;

    constructor(protected featureService: FeatureService) {}

    openModal(): void {}

    closeModal(): void {}

    resetModal(): void {
        this.selectedInfoFields = [];
    }
}
